// extracted by mini-css-extract-plugin
module.exports = {"box":"Coin_box__1u2Gy","coin":"Coin_coin__3bMsl","spin":"Coin_spin__1rdyI"};